import { UnavailabilityError } from "./errors/UnavailabilityError";
export function requireNativeViewManager(viewName) {
  throw new UnavailabilityError('@unimodules/react-native-adapter', 'requireNativeViewManager');
}